export { default } from './Page500';
export { default as template } from './page-500.tpl';
